import {CardItem} from '@domain/last-modified-card-object/card-item';
import {TexfabCardItem} from '@domain/last-modified-card-object/texfab-card-item';
import {AssertionUtils} from '@vdw/angular-component-library';

export class TexfabTuftingLastModified {
  private readonly _productionOrder: CardItem;

  public constructor(texfab: CardItem) {
    this._productionOrder = texfab;
  }

  public get productionOrder(): CardItem {
    return this._productionOrder;
  }

  public static fromJSON(lastModifiedJSON: any): TexfabTuftingLastModified {
    return new TexfabTuftingLastModified(
      new CardItem(
        !AssertionUtils.isNullOrUndefined(lastModifiedJSON.lastModified) ? new TexfabCardItem(lastModifiedJSON.lastModified.id, lastModifiedJSON.lastModified.name) : null,
        lastModifiedJSON.totalCreated
      )
    );
  }
}
